import { Component, Input, OnInit, ViewChild } from '@angular/core';
import { Field } from '@sb-tools/typescript/models/field.model';
import { ClientField } from '../../../common/models/client-field.model';
import { NgSelectComponent, NgSelectModule } from '@ng-select/ng-select';
import { TicketStatus } from '@sb-tools/typescript/enums/ticket-status.enum';
import { FormService } from '../../../common/services/form.service';
import { ControlContainer, FormsModule, NgForm } from '@angular/forms';
import { TicketStatusPipe } from '@form-field-module/common/pipes/ticket-status.pipe';
import { SelectAccessibilityDirective } from '@form-field-module/common/directives/select-accessibility.directive';

@Component({
    selector: 'sb-ticket-status',
    templateUrl: './ticket-status.component.html',
    styleUrls: ['./ticket-status.component.scss'],
    viewProviders: [{ provide: ControlContainer, useExisting: NgForm }],
    imports: [NgSelectModule, FormsModule, TicketStatusPipe, SelectAccessibilityDirective],
})
export class TicketStatusComponent implements OnInit {
    @ViewChild('select') selectElement: NgSelectComponent;

    @Input() formField: Field | ClientField;

    constructor(public formService: FormService) {}

    ngOnInit() {
        this.formField.value = +this.formField.defaultValue || TicketStatus.open;
    }
}
